export default () => ({
  specialities: [],
  speciality: '',

  entities: 'specialities'
})



// WEBPACK FOOTER //
// ./src/app/team/dashboard/gadget/components/identification/resources/data.js